import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftSlideshowArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 11,
	viewBox: "0 0 7 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.68758 11L0.666748 5.97921L5.68758 0.958374L6.58341 1.85421L2.45841 5.97921L6.58341 10.1042L5.68758 11Z" })
});
export default SvgLeftSlideshowArrow;
